import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {API_BASE_URL} from '../../config';
import {useParams} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";
import Button from "../Elements/Button";

const SectionTechniqueDetailsEmails = () => {
    const [providers, setProviders] = useState([]);
    const [selectedEmailProvider, setSelectedEmailProvider] = useState(0);
    const [customerMail1, setCustomerMail1] = useState("");
    const [customerMail2, setCustomerMail2] = useState("");
    const [customerMail3, setCustomerMail3] = useState("");
    const [customerMail4, setCustomerMail4] = useState("");
    const [customerMail5, setCustomerMail5] = useState("");
    const [customerMailExt, setCustomerMailExt] = useState("");
    const [customerMailIsAttached, setCustomerMailIsAttached] = useState(0);
    const [customerSituationMEL, setCustomerSituationMEL] = useState(0);
    let {id} = useParams(); // Get the 'id' parameter from the URL
    id = parseInt(id);
    // Fetch the list of organizations
    useEffect(() => {
        axios
            .post(`${API_BASE_URL}/get_customer_emails_orgs/`, {id})
            .then((res) => {
                console.log('Organization list fetched:', res.data.result);
                setProviders(res.data.result || []);
            })
            .catch((err) => console.error('Error fetching organizations:', err));
    }, [id]);

    // Fetch the current email provider (default radio selection)
    useEffect(() => {
        axios
            .post(`${API_BASE_URL}/get_customer_emails`, {customer_id: id})
            .then((res) => {
                console.log(res.data.result);
                console.log('Current email provider:', res.data.result[0].customer_email_org_id);
                // Assuming res.data.result is a number between 1 and 5
                console.log(res.data.result[0]);
                setSelectedEmailProvider(res.data.result[0].emails_org_id);
                setCustomerMail1(res.data.result[0].mail_1);
                setCustomerMail2(res.data.result[0].mail_2);
                setCustomerMail3(res.data.result[0].mail_3);
                setCustomerMail4(res.data.result[0].mail_4);
                setCustomerMail5(res.data.result[0].mail_5);
                setCustomerMailExt(res.data.result[0].mail_ext);
                setCustomerMailIsAttached(res.data.result[0].is_attached);
                setCustomerSituationMEL(res.data.result[0].situation_mel);
            })
            .catch((err) => console.error('Error fetching current email provider:', err));
    }, [id]);

    const handleRadioChange = (newId) => {
        setSelectedEmailProvider(newId);
    };
    const handleMELChange = (newId) => {
        console.log(newId);
        setCustomerSituationMEL(newId);
    };
    const handleSave = () => {
        console.log(selectedEmailProvider)
        axios
            .post(`${API_BASE_URL}/set_customer_emails`, {
                customer_id: id,
                email_provider: selectedEmailProvider,
                is_attached: customerMailIsAttached,
                mail_1: customerMail1,
                mail_2: customerMail2,
                mail_3: customerMail3,
                mail_4: customerMail4,
                mail_5: customerMail5,
                mail_ext: customerMailExt,
                situation_mel: customerSituationMEL
            })
            .then((res) => {
                console.log('Email provider updated:', res.data.result);
                toast.success("Emails modifiés.");
            })
            .catch((err) => {
                toast.error("Une erreur est survenue lors de l'enregistrement.");
                console.error('Error updating email provider:', err);
            });
    };

    return (<>
        <ToastContainer position="bottom-right" autoClose={3000}/>
        <div className="display-flex flex-direction-column gap-20">
            <h3 className={"color-third"}>Emails</h3>

            <div class="h-separator"></div>

            <h3 className={"color-third mb-10"}>Situation actuelle</h3>
            <div className={"display-flex gap-20 flexwrap-wrap container-1400-col"}>
                <label>Mail rattaché au nom de domaine ?</label>

                <label>
                    <input
                        type="radio"
                        name="mailRattache"
                        value="1"
                        checked={customerMailIsAttached === 1}
                        onChange={() => setCustomerMailIsAttached(1)}
                    /> Oui
                </label>

                <label>
                    <input
                        type="radio"
                        name="mailRattache"
                        value="0"
                        checked={customerMailIsAttached === 0}
                        onChange={() => setCustomerMailIsAttached(0)}
                    /> Non
                </label>
            </div>

            <div className={"display-flex gap-10 flex-direction-column"}>
                <h4 className={"color-third mb-20 mt-20"}>Hébergeur mail actuel</h4>

                <select
                    className="input p-10"
                    value={selectedEmailProvider}
                    onChange={(e) => handleRadioChange(parseInt(e.target.value))}
                >
                    {providers.map((provider) => (<option key={provider.id} value={provider.id}
                                                          dangerouslySetInnerHTML={{__html: provider.name}}/>))}
                </select>

                {(() => {
                    const selected = providers.find(p => p.id === selectedEmailProvider);
                    return selected?.name?.toLowerCase() === "autre" ? (<input
                        className="input p-10 mt-10"
                        type="text"
                        placeholder="Précisez l’hébergeur"
                        value={customerMailExt}
                        onChange={(e) => setCustomerMailExt(e.target.value)}
                    />) : null;
                })()}
            </div>

            <div className={"h-separator"}/>
            <h3 className={"color-third"}>Situation pour MEL</h3>

            <select className={"input p-10"} onChange={(e) => handleMELChange(parseInt(e.target.value))}>
                <option disabled value="">-- Sélectionner --</option>
                <option value={1} selected={customerSituationMEL === 1}>Les mails restent comme ils sont</option>
                <option value={2} selected={customerSituationMEL === 2}>Les mails doivent être basculés chez
                    Infomaniak
                </option>
                <option value={3} selected={customerSituationMEL === 3}>Solution Digitale doit créer des mails</option>
            </select>

            {
                (customerSituationMEL === 2 || customerSituationMEL === 3) &&

            <div className={"display-flex flex-direction-column"}>
                <h4 className={"color-third mb-10"}>Adresses email</h4>
                <div className={"display-flex gap-20 flexwrap-wrap container-1400-col flex-direction-column"}>
                    <div className={"display-flex gap-20"}>
                        <div className={"flex-1 w-100 gap-10 display-flex flex-direction-column"}>
                            Mail 1
                            <input className={"input pl-10"} type="text" value={customerMail1}
                                   onChange={(e) => setCustomerMail1(e.target.value)}/>
                        </div>
                        <div className={"flex-1 w-100 gap-10 display-flex flex-direction-column"}>
                            Mail 2 (optionnel)
                            <input className={"input pl-10"} type="text" value={customerMail2}
                                   onChange={(e) => setCustomerMail2(e.target.value)}/>
                        </div>
                    </div>
                    <div className={"display-flex gap-20"}>

                        <div className={"flex-1 w-100 gap-10 display-flex flex-direction-column"}>
                            Mail 3 (optionnel)
                            <input className={"input pl-10"} type="text" value={customerMail3}
                                   onChange={(e) => setCustomerMail3(e.target.value)}/>
                        </div>
                        <div className={"flex-1 w-100 gap-10 display-flex flex-direction-column"}>
                            Mail 4 (optionnel)
                            <input className={"input pl-10"} type="text" value={customerMail4}
                                   onChange={(e) => setCustomerMail4(e.target.value)}/>
                        </div>
                    </div>
                    <div className={"display-flex gap-20 mb-0"}>
                        <div className={"flex-1 display-flex flex-direction-column"}>
                            <span className={" mb-10"}>Mail 5 (optionnel)</span>
                            <input className={"input pl-10 flex-unset"} type="text" value={customerMail5}
                                   onChange={(e) => setCustomerMail5(e.target.value)}/>
                        </div>
                        <div className={"flex-1 display-flex flex-direction-column"}>
                            <span className={" mb-10"}>Mail pour envoi des nouveaux accès</span>
                            <input className={"input pl-10 flex-unset"} type="text" value={customerMailExt}
                                   onChange={(e) => setCustomerMailExt(e.target.value)}/>
                        </div>
                    </div>
                </div>

            </div>
            }
            <Button onClick={handleSave} icon={"fa-floppy-disk"}
                    label={"Enregistrer"}
                    textClassNames={"bg-third text-white btn-save"}
                    iconBackground={'bg-fifth'} disableLink/>
        </div>


    </>);
};

export default SectionTechniqueDetailsEmails;